import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

export default function CheckResultPage() {
  return (
    <>
      <Navbar />

      <main className="flex flex-col items-center justify-center min-h-screen py-12 bg-gray-50 dark:bg-neutral-900 px-4">
        <div className="text-center mb-8">
          <h2 className="text-3xl font-bold text-gray-800 dark:text-white mb-2">
            Check Your Results – Blessed Montessori
          </h2>
          <p className="text-gray-600 dark:text-gray-300 text-sm max-w-md mx-auto">
            Access your academic performance securely. Click below to view your latest results.
          </p>
        </div>

        <a
          href="https://schoolifix.com/check"
          rel="noopener noreferrer"
          className="px-6 py-3 text-white bg-green-600 hover:bg-green-700 rounded-lg text-sm font-medium transition duration-300"
        >
          Go to Result Page
        </a>
      </main>

      <Footer />
    </>
  );
}
